import ValueGeneratorInterface from "./ValueGeneratorInterface"
import SubtractionValue from "../../Model/Value/SubtractionValue"
import RandomNumberGenerator from "../RandomNumberGenerator"
import NumberValue from "../../Model/Value/NumberValue"

export default class SubtractionValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}
  public supports(): boolean {
    return true
  }

  public generate(value: number): SubtractionValue {
    const minuend: number = this.randomNumberGenerator.randomInt(
      value + 2,
      value * 5,
    )
    const subtrahend: number = minuend - value

    return new SubtractionValue(
      new NumberValue(minuend),
      new NumberValue(subtrahend),
    )
  }
}
